"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StubFilterBackend = void 0;
/**
 * A filter backend that does nothing. Can be used during testing or when filtering support isn't needed.
 */
var StubFilterBackend = /** @class */ (function () {
    function StubFilterBackend() {
    }
    StubFilterBackend.prototype.hashFilters = function (object) {
        return "stub-hash";
    };
    /**
     * Resolves immediately with the {@code source} argument as the result.
     */
    StubFilterBackend.prototype.applyFilters = function (source, object, getDestination) {
        return Promise.resolve(source);
    };
    return StubFilterBackend;
}());
exports.StubFilterBackend = StubFilterBackend;
//# sourceMappingURL=StubFilterBackend.js.map